module.exports = __webpack_public_path__ + "img/DE01635.52e040a7.png";